export const cleanPhoneNumber = (phone: string) => {
  // TODO: проверка длинны ситроки
  return phone.replace(/[\s\\(\\)\\-]/g, '').substring(1);
};
